/* eslint-disable @typescript-eslint/camelcase */
import { RoleFields } from 'modules/permission/interfaces';

export const initialValues: RoleFields = {
  name: '',
  description: '',
  from_template: '',
  active: true,
};
